// src/components/pages/SolutionPage.js
import React from 'react';
import { Box, Grid } from '@mui/material';
import { SOLUTION_DATA } from '../../data/solutionData';
import HeroBanner from '../common/HeroBanner';
import FeatureCard from '../common/FeatureCard';
import DescriptionBlock from '../common/DescriptionBlock';

const SolutionPage = ({ pageId }) => {
  const content = SOLUTION_DATA[pageId];

  if (!content) {
    return <Box sx={{ p: 4 }}>페이지를 찾을 수 없습니다.</Box>;
  }

  // heroOverlay가 명시적으로 false인 경우, 이미지는 깨끗하게 보여주고
  // 제목/설명은 아래 DescriptionBlock(검은 배경)에서 따로 보여줍니다.
  const useOverlay = content.heroOverlay !== false;

  return (
    <Box sx={{ width: '100%' }}>
      <HeroBanner
        image={content.heroImage}
        title={content.title}
        tagline={content.tagline}
        overlay={useOverlay}
      />

      {!useOverlay && content.description && (
        <DescriptionBlock
          title={content.description.title}
          paragraphs={content.description.paragraphs}
        />
      )}

      <Box sx={{ p: { xs: 3, md: 5 } }}>
        <Grid container spacing={3}>
          {content.categories.map((category, index) => (
            <Grid item xs={12} md={4} key={index}>
              <FeatureCard
                image={category.image}
                title={category.title}
                description={category.description}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default SolutionPage;

